/**
 * Shape of the orchestrator's `navigate` event on the `/events`
 * stream. The agent emits this when it wants the UI to move to a
 * specific in-app route while keeping the chat panel open — e.g.,
 * immediately after a `create_routine` tool call completes,
 * "create + navigate to /routines/:id + keep chat open".
 */
export interface NavigateEvent {
  type: 'navigate';
  /** Router-relative path the UI should push (e.g., `/routines/abc123`). */
  url: string;
}

/**
 * Discriminator for events arriving on the `/events` stream as
 * `unknown` payloads. Use this to narrow before dispatching to the
 * navigate handler — bad lines should never crash the panel.
 */
export function isNavigateEvent(event: unknown): event is NavigateEvent {
  if (event === null || typeof event !== 'object') return false;

  const candidate = event as { type?: unknown; url?: unknown };

  return candidate.type === 'navigate' && typeof candidate.url === 'string';
}
